var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermalinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "10px",
    viewBox: "0 0 20 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "permalink-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "permalink-icon-group2",
    transform: "translate(-1332.000000, -229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "permalink-icon-group3",
    transform: "translate(1330.000000, 222.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "permalink-icon-rect",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "permalink-icon-group4",
    transform: "translate(2.000000, 7.000000)",
    fill: "#515D75",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9,5 C1.9,3.29 3.29,1.9 5,1.9 L9,1.9 L9,0 L5,0 C2.24,0 0,2.24 0,5 C0,7.76 2.24,10 5,10 L9,10 L9,8.1 L5,8.1 C3.29,8.1 1.9,6.71 1.9,5 Z M6,6 L14,6 L14,4 L6,4 L6,6 Z M15,0 L11,0 L11,1.9 L15,1.9 C16.71,1.9 18.1,3.29 18.1,5 C18.1,6.71 16.71,8.1 15,8.1 L11,8.1 L11,10 L15,10 C17.76,10 20,7.76 20,5 C20,2.24 17.76,0 15,0 Z",
    id: "permalink-icon-path1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermalinkIcon);
export default __webpack_public_path__ + "static/media/permalink-icon.6d6beeb1.svg";
export { ForwardRef as ReactComponent };